import { useEffect } from 'react';

import { type ShareState, useChartMenuContext } from '../ChartMenuContext';

/**
 * Registers the chart's Replots type and props with the chart menu, powering
 * PPT export of an individual plot. Share links are built from the snapshot the
 * `withShareCapture` HOC on each replots export captures instead.
 */
export const usePlotShareData = ({ chartType, chartProps }: ShareState) => {
  const { setShareData } = useChartMenuContext();
  const stringifiedChartProps = JSON.stringify(chartProps);

  useEffect(() => {
    setShareData({
      chartType,
      chartProps: JSON.parse(stringifiedChartProps),
    });
  }, [stringifiedChartProps, chartType, setShareData]);
};
